module.exports = __webpack_public_path__ + "static/media/greenAgrosLogo.23a8e758.png";